import { Http } from '@/core';
import { guard } from '@/utils';
import {
  TermsAndConditionsDto,
  UpdateTermsAndConditionsDto,
} from './termsAndConditionsTypes';

class TermsAndConditionsHttp extends Http {
  public async get(organizationId: string) {
    const response = await this._axios.get<TermsAndConditionsDto[]>(
      `/api/terms`,
      {
        params: { organizationId },
      },
    );
    return response.data;
  }

  public async getPending() {
    const response = await this._axios.get<TermsAndConditionsDto | null>(
      `/api/terms/pending`,
    );
    return response.data;
  }

  public async getVersion(id: string) {
    guard.notNull(id, 'id');
    const response = await this._axios.get<TermsAndConditionsDto>(
      `/api/terms/${id}`,
    );
    return response.data;
  }

  public async update(request: UpdateTermsAndConditionsDto) {
    guard.notNull(request, 'request');
    await this._axios.post('/api/terms', request);
  }
}

export const termsAndConditionsHttp = new TermsAndConditionsHttp();
